import { transitionMotorInsurancePersonalDetailsForm } from '../../../actions/naMotorInsurance/personalDetails';
import { getPersonalDetailsForm } from '../../../selectors/naMotorInsurance/personalDetails';

import { FIELD_STATUS } from '../../../reducers/status';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const personalDetailsFormRules = (store, next, action) => {
    const result = next(action);
    const personalDetailsForm = getPersonalDetailsForm(store.getState());
    const personalDetailsFormValid = validatePersonalDetailsFormDetails(personalDetailsForm);

    const formAction = personalDetailsFormValid
        ? transitionMotorInsurancePersonalDetailsForm.formValid()
        : transitionMotorInsurancePersonalDetailsForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validatePersonalDetailsFormDetails = (formFields) => {
    const commonChecks =
        formFields.dob &&
        formFields.dob.status === FIELD_STATUS.VALID &&
        formFields.gender &&
        formFields.gender.status === FIELD_STATUS.VALID &&
        formFields.firstName &&
        formFields.firstName.status === FIELD_STATUS.VALID &&
        formFields.lastName &&
        formFields.lastName.status === FIELD_STATUS.VALID &&
        formFields.nationality &&
        formFields.nationality.status == FIELD_STATUS.VALID &&
        formFields.phoneNumber &&
        formFields.phoneNumber.status === FIELD_STATUS.VALID &&
        formFields.email &&
        formFields.email.status === FIELD_STATUS.VALID &&
        formFields.town &&
        formFields.town.status === FIELD_STATUS.VALID;

    const passportChecks =
        formFields.passportNumber &&
        formFields.passportNumber.status == FIELD_STATUS.VALID &&
        formFields.passportOrigin &&
        formFields.passportOrigin.status == FIELD_STATUS.VALID &&
        formFields.passportExpiry &&
        formFields.passportExpiry.status == FIELD_STATUS.VALID;

    if (formFields.nationality.value !== 'Namibian') {
        return commonChecks && passportChecks;
    }

    return commonChecks && formFields.idNumber && formFields.idNumber.status === FIELD_STATUS.VALID;
};
